<template>
  <div class="user-manage layout">
    <div
      v-if="($store.getters['system/getSuperAuth'] || client === 'back') && $route.name !== 'make'"
      class="layout-menu"
    >
      <el-menu
        class="portal"
        text-color="#333"
        router
        :unique-opened="true"
        :default-active="cp_defaultActive"
      >
        <recursive-menu-item
          v-for="(item, idx) in navMenus.menuItems"
          v-if="item.access.actionsCode.indexOf('04202001') === -1 || authority"
          :key="idx"
          :item="item"
        />
      </el-menu>
    </div>
    <div
      class="portal-content"
      :class="($store.getters['system/getSuperAuth'] || client === 'back') && $route.name !== 'make' ? 'layout-content' : ''"
    >
      <keep-alive
        :include="include"
        :exclude="exclude"
        :max="max"
      >
        <router-view />
      </keep-alive>
    </div>
  </div>
</template>

<script>
import { RecursiveMenuItem } from './childComponent';

export default {
    name: 'BaseMenu',
    components: { RecursiveMenuItem },
    data () {
        return {
            navMenus: {
                defaultActive: '',
                menuItems: [],
            },
            site: '',
            include: [],
            exclude: [],
            max: 10,
        };
    },
    computed: {
        cp_defaultActive () {
            return this.$route.meta.activeMenu || this.$route.path;
        },
        client () {
            let res = 'back';
            this.$route.matched.forEach(r => {
                if (r.meta.client) {
                    res = r.meta.client;
                }
            });
            return res;
        },
        userIdentity () {
            return this.$store.getters['global/userIdentity'];
        },
        authority () {
            return this.userIdentity === 1 || this.userIdentity === 2;
        },
    },
    mounted () {
        this.$store.commit('global/nav/mu_travelSite', { site: this.site });
    },
};
</script>

<style lang="scss">
@import "../../sass/theme.scss";
.layout {
    min-width: 1250px;
    position: relative;
    .layout-menu {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        z-index: 1;
        background: #fff;
        overflow-x: auto;
        width: 240px;
    }
    .layout-content {
        margin-left: 244px;
        padding: 0 20px;
    }
    .layout-cont-box {
        background: #fff;
        & + .layout-cont-box {
            margin-top: 12px;
        }
    }
}
</style>

<style lang="scss">
</style>
